export const DefaultContent = ({
  doc, // = docExample,
}: {
  doc: string | null;
}) => {
  let src;

  if (doc?.startsWith("data:")) {
    src = doc as string;
  } else {
    // src = atob(doc as string);
    src = `data:application/pdf;base64,${doc}`;
  }

  return <iframe src={src} width="100%" height="100%" />;
};
